import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container,Row,Col,Card } from 'react-bootstrap';
import { useCountUp } from 'react-countup';
import { useDataContext } from '../../DataContext';
const AdCounters = () => 
{
    const { t } = useTranslation();
    const { globalData } = useDataContext();
    useCountUp({
        ref: 'crOne',
        start:0,
        end: (globalData) ? globalData.sg_publication_count : 550,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crTwo',
        start:0,
        end: (globalData) ? globalData.sg_alumni_count : 2600,
        suffix:'+',
        enableScrollSpy: true,
    });
    useCountUp({
        ref: 'crThree',
        start:0,
        end: (globalData) ? globalData.sg_student_count : 2800,
        suffix:'+',
        enableScrollSpy: true,
      });
      useCountUp({
        ref: 'crFour',
        start:0,
        end: (globalData) ? globalData.sg_placements_count : 2000,
        suffix:'+',
        enableScrollSpy: true,
      });
    return (
        <section className="ad-counter">
            <Container className="py-3 text-center">
                <Row className='g-4' id="countup-target">
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <Card className='text-bg-info text-white p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crOne' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {t('Publications')}
                                </div>
                            </Card.Body>
                        </Card>                       
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <Card className='text-bg-info bg-info-subtle p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crTwo' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {t('Alumni')}
                                </div>
                            </Card.Body>
                        </Card> 
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <Card className='text-bg-info text-white p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crThree' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {t('Students')}
                                </div>
                            </Card.Body>
                        </Card> 
                    </Col>
                    <Col xs={6} lg={3} data-aos="zoom-in" data-aos-duration="1500">
                        <Card className='text-bg-info bg-info-subtle p-3'>
                            <Card.Body className='border border-white'>
                                <div className="counters display-4 fw-bold">
                                    <span id='crFour' />
                                </div>
                                <div className="text fw-bold text-uppercase">
                                    {t('Placements')}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default AdCounters;